import React from "react";
import classes from "./LazyLoader.module.css";
import logo from "../../../../assets/Next_Generation_Logo.png";

const LazyLoader = () => {
  return (
    <div className={classes.backdrop}>
      <img src={logo} alt="Next Generation" className={classes.logo} />
    </div>
  );
};

export default LazyLoader;
